import { loadingSpinner, errorPopup, successPopup } from './utils.js';

async function fetchComplianceData() {
    try {
        const chainID = $('#chain-id').val();
        const verificationRefID = $('#verification-reference-id').val();
        $('#get-compliance-data').html(loadingSpinner);
        const complianceData = await (
            verificationRefID.length == 66 && verificationRefID.startsWith('0x') ?
            getFullComplianceData(chainID, verificationRefID) :
            getComplianceData(chainID, verificationRefID)
        );
        successPopup('Compliance data fetched successfully');
        $('#compliance-data').text(complianceData);
    } catch (error) {
        errorPopup(error);
        $('#compliance-data').text('');
    }
    finally {
        $('#get-compliance-data').text('Get compliance data');
    }
}

$(document).ready(function() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('verification-reference-id'))
        $('#verification-reference-id').val(searchParams.get('verification-reference-id'));
    if (searchParams.has('chain-id'))
        $('#chain-id').val(searchParams.get('chain-id'));

    $('#fetch-compliance-data-form').on('submit', function(e) {
        e.preventDefault();
        fetchComplianceData();
    });
});
